type StringFilterTag = {
  filterType: string;
  value: string;
};

export const getIsOnlyNatSelected = (renderStringFilters: StringFilterTag[]): boolean => {
  const regionFiltersSelected = renderStringFilters.filter(
    (toCheck) => toCheck.filterType === 'offerRegion',
  );
  return (
    regionFiltersSelected.length === 1 &&
    regionFiltersSelected.some((toCheck) => toCheck.value === 'NAT')
  );
};

export const getShouldShowRemoveAllFilters = (
  renderStringFilters: StringFilterTag[],
  isCaMarket: boolean,
  filterCount: number,
): boolean => {
  const isOnlyNatSelected = getIsOnlyNatSelected(renderStringFilters);
  return (
    (isCaMarket && renderStringFilters.length > 1) ||
    (isCaMarket && renderStringFilters.length === 1 && !isOnlyNatSelected) ||
    (!isCaMarket && !!filterCount)
  );
};
